import shikuang from "@/static/dataApi/gray/shikuang.png";
import shikuang_color from "@/static/dataApi/color/shikuang.png";

import yubao from "@/static/dataApi/gray/yubao.png";
import yubao_color from "@/static/dataApi/color/yubao.png";

import yujing from "@/static/dataApi/gray/yujing.png";
import yujing_color from "@/static/dataApi/color/yujing.png";

import kongzhi from "@/static/dataApi/gray/kongzhi.png";
import kongzhi_color from "@/static/dataApi/color/kongzhi.png";

import zhishu from "@/static/dataApi/gray/zhishu.png";
import zhishu_color from "@/static/dataApi/color/zhishu.png";

import haiyang from "@/static/dataApi/gray/haiyang.png";
import haiyang_color from "@/static/dataApi/color/haiyang.png";

import tuceng from "@/static/dataApi/gray/tuceng.png";
import tuceng_color from "@/static/dataApi/color/tuceng.png";

import jingxi from "@/static/dataApi/gray/jingxi.png";
import jingxi_color from "@/static/dataApi/color/jingxi.png";

import gongju from "@/static/dataApi/gray/gongju.png";
import gongju_color from "@/static/dataApi/color/gongju.png";

export default [
  {
    name: "天气实况类",
    hot: false,
    isSubShow: false,
    id: "0",
    icon: shikuang,
    colorIcon: shikuang_color,
    data: [
      {
        name: "天气实况",
        id: "00",
        isUsed: "",
        description: "按城镇名称或行政区编码查询，查询城镇天气实况",
      },
      {
        name: "24小时（历史）天气实况",
        id: "01",
        isUsed: "",
        description: "按城镇名称或行政区编码查询，查询城镇最近24小时天气实况",
      },
    ],
  },
  {
    name: "天气预报类",
    hot: false,
    isSubShow: false,
    id: "1",
    icon: yubao,
    colorIcon: yubao_color,
    data: [
      {
        name: "短临预报",
        id: "00",
        isUsed: "",
        description:
          "提供全国范围内的短临雷达图层数据",
      },
      {
        name: "逐小时预报",
        id: "01",
        isUsed: "",
        description:
          "按城镇名称或行政区编码查询，最近15天预报数据，数据时间间隔为1小时",
      },
      {
        name: "逐日预报",
        id: "02",
        isUsed: "",
        description:
          "按城镇名称或行政区编码查询，最近40天预报数据，每天三条数据，数据时间分别为每天8时/12时/20时各1次",
      },
      {
        name: "气候趋势预测",
        id: "03",
        isUsed: "",
        description:
          "按城镇名称或行政区编码查询，最近15天预报数据，数据时间间隔为12小时，每天两条数据，分别为上午、下午天气情况",
      },
    ],
  },
  {
    name: "天气预警类",
    hot: false,
    isSubShow: false,
    id: "7",
    icon: yujing,
    colorIcon: yujing_color,
    data: [
      {
        name: "城市天气预警",
        id: "00",
        isUsed: "",
        description: `可按“行政区划编码”查询当地正在生效或者未生效但已发布的关注预警事件列表。`,
      },
      {
        name: "全国天气预警",
        id: "01",
        isUsed: "",
        description: `查询全国正在生效或者未生效但已发布的关注预警事件列表。`,
      },
      {
        name: "地质灾害风险预警",
        id: "02",
        isUsed: "",
        description: `可按“行政区划编码”查询当地正在生效或者未生效但已发布的关注地质灾害风险预警`,
      },
      {
        name: "气象预警事件类型列表",
        id: "04",
        isUsed: "",
        description: `可查询全部的预警事件类型列表`,
      },
    ],
  },
  {
    name: "空气质量类",
    hot: false,
    isSubShow: false,
    id: "13",
    icon: kongzhi,
    colorIcon: kongzhi_color,
    data: [
      {
        name: "空气质量实况",
        id: "00",
        isUsed: "",
        description: `按城镇名称或行政区编码查询，查询城镇空气质量实况，逐小时更新`,
      },
      {
        name: "历史空气质量",
        id: "01",
        isUsed: "",
        description: `按城镇名称或行政区编码查询，逐小时资料，2014年-至今,所以月亮高度角的变化规律也很复杂,而不是象太阳高度角那样随四季变化。`,
      },
      {
        name: "1天逐小时空气质量预报",
        id: "02",
        isUsed: "",
        description: `按照经纬度或城市查询未来24小时逐小时空气质量（12KM*12KM精度）`,
      },
      {
        name: "5天逐日空气质量预报",
        id: "03",
        isUsed: "",
        description: `按照经纬度或城市查询未来5天逐日或逐小时空气质量（12KM*12KM精度）`,
      },
      {
        name: "空气质量实时排行",
        id: "04",
        isUsed: "",
        description: `实时查询城市空气质量排名`,
      },
    ],
  },
  {
    name: "生活信息类",
    hot: true,
    isSubShow: false,
    id: "11",
    icon: zhishu,
    colorIcon: zhishu_color,
    data: [
      {
        name: "生活指数",
        id: "00",
        isUsed: "",
        description: `查询最近一周气象生活指数。`,
      },
      {
        name: "日出日落",
        id: "01",
        isUsed: "",
        description: `城市或经纬度查询未来40天日出及日落时间`,
      },
      {
        name: "月出月落和月相",
        id: "06",
        isUsed: "",
        description: `城市或经纬度查询未来40天月出及月落时间、月相`,
      },
      {
        name: "尾号限行",
        id: "03",
        isUsed: "",
        description: `城市查询未来3-15天尾号限行`,
      },
    ],
  },
  {
    name: "海洋气象类",
    hot: false,
    isSubShow: false,
    id: "6",
    icon: haiyang,
    colorIcon: haiyang_color,
    data: [
      {
        name: "台风实况",
        id: "00",
        isUsed: "",
        description: `台风实况：按台风编号查询这个台风从生成到现在的所有轨迹信息。
        台风最新位置：按台风编号查询这个台风的最新中心点信息。`,
      },
      {
        name: "台风预报",
        id: "01",
        isUsed: "",
        description: `按台风编号查询这个台风的最新预报。`,
      },
      {
        name: "台风列表",
        id: "02",
        isUsed: "",
        description: `按年查询台风信息`,
      },
      {
        name: "浪涌预报",
        id: "04",
        isUsed: "",
        description: `按照经纬度查询东亚地区海洋浪涌预报。空间分辨率10KM，0-120小时逐小时资料，120-240小时逐3小时资料`,
      },
      {
        name: "潮汐预报",
        id: "05",
        isUsed: "",
        description: `指定港口或者某城市下属全部港口，未来18天逐小时`,
      },
    ],
  },
  {
    name: "天气图层类",
    hot: true,
    isSubShow: false,
    id: "2",
    icon: tuceng,
    colorIcon: tuceng_color,
    data: [
      {
        name: "颠簸预报",
        id: "00",
        isUsed: "",
        description: `全球范围内未来5天逐小时地面到高空超40个高度颠簸指数。`,
      },
      {
        name: "积冰预报",
        id: "01",
        isUsed: "",
        description: `全球范围内未来5天逐小时地面到高空超40个高度积冰指数。`,
      },
      {
        name: "卫星云图",
        id: "02",
        isUsed: "",
        description: `覆盖中国区域的卫星云图。PNG/GeoTiff  格式，5-15分钟更新频次，墨卡托投影`,
      },
      {
        name: "实况雷达图层",
        id: "03",
        isUsed: "",
        description: `中国区实况雷达拼图。PNG 或 JPG格式，每6分钟更新`,
      },
      {
        name: "预报雷达图层",
        id: "04",
        isUsed: "",
        description: `中国区未来2小时雷达预报拼图。PNG 或 JPG格式，每6分钟更新未来2小时逐6分钟数据`,
      },
      {
        name: "气象预报图层（中国）",
        id: "05",
        isUsed: "",
        description: `中国区未来10天地面12要素逐小时预报。每天更新两次未来10天逐小时资料，PNG、GeoTIFF、GeoJSON格式，5KM*5KM精度`,
      },
      {
        name: "分钟级降水预报图层",
        id: "06",
        isUsed: "",
        description: `中国区未来2小时分钟级降水预报。PNG、JPG、TIFF、GeoJSON格式，每6分钟更新的未来2小时逐6分钟降水预报图层`,
      },
      {
        name: "高空温度可视化瓦片图层",
        id: "07",
        isUsed: "",
        description: `中国区从地面到高空超40个高度层未来10天逐小时温度预报。每天更新两次未来10天逐小时资料，PNG、GeoTIFF、GeoJSON格式，高度层`,
      },
      {
        name: "高空相对湿度可视化瓦片图层",
        id: "08",
        isUsed: "",
        description: `中国区从地面到高空超40个高度层未来10天逐小时相对湿度预报。每天更新两次未来10天逐小时资料，PNG、GeoTIFF、GeoJSON格式`,
      },
      {
        name: "高空风场图层",
        id: "09",
        isUsed: "",
        description: `中国区从地面到高空超40个高度层未来10天逐小时风向风速预报。每天更新两次未来10天逐小时资料，PNG、GeoTIFF、GeoJSON格式`,
      },
      {
        name: "实况降水图",
        id: "10",
        isUsed: "",
        description: `中国区逐6分钟降水实况。`,
      },
    ],
  },
  {
    name: "精细化产品",
    hot: false,
    isSubShow: false,
    id: "12",
    icon: jingxi,
    colorIcon: jingxi_color,
    data: [
      {
        name: "逐小时网格实况（1x1公里）",
        id: "00",
        isUsed: "",
        description: `按照经纬度查询中国区地面逐小时11个要素的实况数据。`,
      },
      {
        name: "15天5x5公里逐日预报",
        id: "01",
        isUsed: "",
        description: `按指定经纬度查询中国区未来15天逐日预报数据。每天8时和20时各更新1次`,
      },
      {
        name: "40天5x5公里逐日预报",
        id: "02",
        isUsed: "",
        description: `按指定经纬度查询，最近40天预报数据。每天8时和20时各更新1次`,
      },
      {
        name: "15天5x5公里逐小时预报",
        id: "03",
        isUsed: "",
        description: `按指定经纬度查询，最近15天逐小时预报数据。`,
      },
      {
        name: "（历史）网格实况",
        id: "04",
        isUsed: "",
        description: `中国区历史（2018年-至今）网格实况数据。1KM*1KM精度，csv格式`,
      },
      {
        name: "（历史）网格预报",
        id: "04",
        isUsed: "",
        description: `中国区历史（2018年-至今）网格预报数据。9KM*9KM精度，未来10天逐小时，起报时间每天08和20时`,
      },
      {
        name: "短临强对流预报",
        id: "04",
        isUsed: "",
        description: `中国区未来2小时强对流预报。逐6分钟更新未来2小时逐6分钟数据，PNG 或 JPG格式`,
      },
      {
        name: "闪电定位",
        id: "04",
        isUsed: "",
        description: `中国区闪电实况数据。逐分钟更新`,
      },
      {
        name: "大江大河",
        id: "04",
        isUsed: "",
        description: `中国区大江大河位置分布信息。`,
      },
    ],
  },
  {
    name: "辅助工具类",
    hot: false,
    isSubShow: false,
    id: "8",
    icon: gongju,
    colorIcon: gongju_color,
    data: [
      {
        name: "城市查询",
        id: "00",
        isUsed: "",
        description: `根据城市ID、中文、英文、拼音、IP、经纬度搜索匹配的城市`,
      },
      {
        name: "天气聊天机器人",
        id: "01",
        isUsed: "",
        description: `中国区大江大河位置分布信息。`,
      },
    ],
  },
];
